"use client";

import { useFormStore, type FormState } from "@/stores";

export type { FormState };

const useForm = (): FormState => useFormStore();

export { useForm };
